const category = 'AppSpecificWorkManagement';

const cards = [
    {
        name: "Liability Processing",
        id: "DeferLiabilityProcessinginRecovery",
        fields: [
            [{id: 'DeferLiabilityProcessinginRecovery'}]
        ],
    },
    {
        name: "Assignment Routing",
        id: "TieredServicesAssignmentRouting",
        fields: [
            [{id: 'TieredServicesIsClientAssignmentsEnabled'}],
            [{id: 'ClientAssignmentGroupContent'}],
            [{id: 'TieredServicesConfiguration'}],
            [{id: 'TieredServicesIsTransferAssignmentsEnabled'}],
            [{id: 'TransferClientAssignmentContent'}],
            [{id: 'IsTransferableClientAssignmentInboundCorrespondence'}],
        ]
    }
];

export { cards, category };